import map from 'lodash/map';

import type { ComparisonFeatureItem } from '@/features/Comparison/Components/types';
import { FEATURE } from '@/features/Features/store';
import type {
  FeatureApiResponse,
  FeatureGroup,
  FeatureItem,
} from '@/features/Features/types';

export const buildFeatureData = (data: FeatureApiResponse): FeatureGroup[] => {
  const result: FeatureGroup[] = [];

  map(data.merkmale, (featureGroup) => {
    const items: FeatureItem[] = [];

    map(featureGroup.items, (remoteFeature) => {
      const feature = {
        ...remoteFeature,
        value: FEATURE.UNCHECKED,
      };

      if (remoteFeature.requirements !== undefined) {
        feature.requirements = Object.freeze(remoteFeature.requirements);
      }

      items.push(feature);
    });

    result.push({
      type: featureGroup.type,
      label: featureGroup.label,
      meta: featureGroup.meta ?? null,
      items,
      rubrik: featureGroup.rubrik,
    });
  });

  return result;
};

export const convertFeatureItemsToComparisonItems = (
  group: FeatureGroup,
): ComparisonFeatureItem[] =>
  group.items.map((item) => ({
    label: item.label,
    meta: item.meta,
    hinweis: item.hinweis,
    value: item.value,
    identifier: item.identifier,
    parentMeta: group.meta ?? undefined,
  }));

export const transformFeaturesToIdentifierObject = (
  featureGroups: FeatureGroup[],
) => {
  let result: Record<string, FeatureItem> = {};

  const addItem = (ctx: Record<string, FeatureItem>, item: FeatureItem) => {
    if (item.value === undefined) {
      item.value = FEATURE.UNCHECKED;
    }

    if (item.identifier !== undefined) {
      ctx[item.identifier] = item;
    }

    if (item.items !== undefined) {
      item.items.forEach((entry) => addItem(ctx, entry));
    }

    return ctx;
  };

  map(featureGroups, (featureGroup: FeatureGroup) => {
    map(featureGroup.items, (featureItem: FeatureItem) => {
      result = addItem(result, featureItem);
    });
  });

  return result;
};
